import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NGaugeService } from './shared/ngauge.service';
import { AuthService } from './shared/auth.service';

@Injectable()
export class ContractService {
  constructor(
    private ngaugeService: NGaugeService,
    private authService: AuthService,
    private httpClient: HttpClient
  ) {}

  getColumnAttributes(content, font) {
    return {
      text: content,
      style: "tableHeader",
      alignment: "center",
      fontSize: font,
    };
  }

  getTableHeaders(newColumnsFortable) {
    const header = [];
    for (const item of newColumnsFortable) {
      if (item.header !== "") {
        if (item.header.includes("(")) {
          item.header = item.header.split("(").join("\n(");
        }
        const currenttext = this.getColumnAttributes(item.header, 9);
        currenttext["fillColor"] = "#dedede";
        header.push(currenttext);
      }
    }
    return header;
  }

  populateTabelColumns(newColumnsFortable, newObject) {
    const data = [];
    data[0] = this.getTableHeaders(newColumnsFortable);
    for (let i = 0; i < newObject.length; i++) {
      const lists = [];
      for (let m = 0; m < newObject[i].length; m++) {
        if (newObject[i][m] !== "" || m === 1) {
          const currenttext = this.getColumnAttributes(
            newObject[i][m],
            m === 0 ? 9 : 8
          );
          currenttext["bold"] = m === 0 ? true : false;
          lists.push(currenttext);
        }
      }
      if (lists[0] !== "") {
        data[i + 1] = lists;
      }
    }
    const newArray = [];
    for (const item of data) {
      if (item.length > 0) {
        if (item[0].text !== "") {
          newArray.push(item);
        }
      }
    }
    const columnWidth = 100 / newArray[0].length;
    const width = [];
    for (const item of newArray[0]) {
      if (item) {
        width.push(columnWidth + "%");
      }
    }
    return { newArray, width };
  }

  buildGroupTable(newColumns, groupAgreement) {
    const newColumnsFortable = [];
    for (let i = 0; i < newColumns.length - 6; i++) {
      newColumnsFortable.push(newColumns[i]);
    }
    newColumnsFortable.push({
      columnDef: "Total Nights",
      header: "Total Nights",
      id: "totalNight",
    });
    groupAgreement.docName = "GROUP_AGREEMENT";
    const newObject1: any = this.getnewColumns(newColumns, groupAgreement);
    const newObject = newObject1["newObject"];
    for (
      let i = 2;
      i < newColumnsFortable.length - 1 && newObject1.roomRate[i - 2] !== 0;
      i++
    ) {
      newColumnsFortable[i].header =
        newColumnsFortable[i].header +
        " ($" +
        parseFloat(newObject1["roomRate"][i - 2]).toFixed(2) +
        ")";
    }
    return { newObject, newColumnsFortable };
  }

  getnewColumns(newColumns, groupFunctionData, newObject = []) {
    const updatedColumns = [];
    const roomRate = [];
    for (let i = 0; i < newColumns.length - 6; i++) {
      if (newColumns[i]["header"] !== "") {
        updatedColumns.push(newColumns[i]["header"]);
      }
    }
    if (
      groupFunctionData.roomBlockInfo.length <
      groupFunctionData.RoomDetail.length
    ) {
      for (let i = 0; i < groupFunctionData.RoomDetail.length; i++) {
        roomRate.push(groupFunctionData.RoomDetail[i].rate);
        newObject[i] = [];
        if (i >= groupFunctionData.roomBlockInfo.length) {
          for (let b = 0; b < updatedColumns.length; b++) {
            newObject[i][newObject[i].length] = "";
          }
        } else {
          newObject[i] = this.updateRoomBlock(
            groupFunctionData.roomBlockInfo[i],
            updatedColumns,
            newObject[i]
          );
        }
      }
    } else if (
      groupFunctionData.roomBlockInfo.length >
      groupFunctionData.RoomDetail.length
    ) {
      for (let i = 0; i < groupFunctionData.roomBlockInfo.length; i++) {
        const rate =
          groupFunctionData.RoomDetail[i] !== undefined
            ? groupFunctionData.RoomDetail[i].rate
            : 0;
        roomRate.push(rate);
        newObject[i] = [];
        newObject[i] = this.updateRoomBlock(
          groupFunctionData.roomBlockInfo[i],
          updatedColumns,
          newObject[i]
        );
      }
    } else {
      for (let i = 0; i < groupFunctionData.roomBlockInfo.length; i++) {
        roomRate.push(groupFunctionData.RoomDetail[i].rate);
        newObject[i] = [];
        newObject[i] = this.updateRoomBlock(
          groupFunctionData.roomBlockInfo[i],
          updatedColumns,
          newObject[i]
        );
      }
    }
    // Changed temporarily for AC_Mariotte-Group_Agreement not implemented in Other contracts
    let returnObj;
    if (groupFunctionData.docName === "GROUP_AGREEMENT") {
      returnObj = { newObject: newObject, roomRate: roomRate };
    } else {
      returnObj = newObject;
    }
    return returnObj;
  }

  updateRoomBlock(roomBlock, updatedColumns, newObject = []) {
    const temproomBlockInfo = JSON.parse(JSON.stringify(roomBlock));
    newObject[updatedColumns.length] = 0;
    for (let p = 0; p < updatedColumns.length; p++) {
      newObject[p + 0] = temproomBlockInfo[updatedColumns[p]];
      if (newObject[0] === "Total") {
        newObject[0] = "Total Room Nights";
      }
      if (p > 1) {
        newObject[updatedColumns.length] += Number(newObject[p + 0]);
      }
    }
    return newObject;
  }

  convertEpochDate(date) {
    const utcSeconds = date;
    const d = new Date(0); // The 0 there is the key, which sets the date to the epoch
    return new Date(d.setUTCSeconds(utcSeconds));
  }

  getContractDashboard() {
    const fields = '"fields": ["id", "status", "SID"]';
    const filter =
      '{ "fields": ["id", "status", "SID"], "where": { "SID": ' +
      this.authService.getSID() +
      " } }";
    const params = { params: this.ngaugeService.getHttpParams(filter) };
    return this.httpClient.get(
      this.ngaugeService.getMeldURL("CONTRACT_SIGN"),
      params
    );
  }

  getContract(property: string) {
    let params = new HttpParams();
    params = params.append('property', property);
    params = params.append('SID', sessionStorage.getItem('sid'));
    return this.httpClient.get(this.ngaugeService.getMeldURL('GET_CONTRACTS'), { params });
  }

  downloadContract(url, status) {
    return this.httpClient.post(this.ngaugeService.getMeldURL("GET_SIGN_URL"), {
      url,
      status,
    });
  }

  getClaimUrl(mailinfo) {
    return this.httpClient.post(
      this.ngaugeService.getMeldURL("GET_CLAIM_URL"),
      { mailinfo }
    );
  }

  sendPdf(contractinfo) {
    return this.httpClient.post(this.ngaugeService.getMeldURL("SEND_PDF"), {
      contractinfo,"SID":this.authService.getSID()
    });
  }

  getAgreementViewStatus(
    reportId: number,
    reportType: string,
    documentId: number
  ) {
    const params = { reportDetails: { reportId, reportType }, SID: this.authService.getSID() };
    if (documentId !== undefined) {
      params["reportDetails"]["documentId"] = documentId.toString();
    }
    return this.httpClient.post(
      this.ngaugeService.getMeldURL("GET_CONTRACT_STATUS"),
      params
    );
  }

  sendNotification(value) {
    const params = { reportDetails: value };
    return this.httpClient.post(
      this.ngaugeService.getMeldURL("SEND_NOTIFICATION"),
      params
    );
  }

  updateSignRequest(value) {
    return this.httpClient.post(
      this.ngaugeService.getMeldURL("UPDATE_CONTRACT"),
      value
    );
  }


  cancelRequest(signatureRequestId,emailID) {
    const params = { signatureRequestId, emailId : emailID };
    return this.httpClient.post(
      this.ngaugeService.getMeldURL("CANCEL_REQUEST"),
      params
    );
  }

  getAccountDetails(accountId) {
    const contactFields =
      '"fields": ["id", "image", "firstName", "lastName", "designation", "phoneNumber", "fax",' +
      ' "type", "email", "workEmail", "assistant", "address", "city", "state", "zip"]';
    const includeContact =
      '"include":{"relation": "contact", "scope":{' + contactFields + "}}";
    const whereCondition = '"where": {"id":' + accountId + ', "SID":' + this.authService.getSID() + ' }';


    const columnFilter = '"fields": ["name","account","id", "type", "status","SID"]';
    const filter =
      "{" + whereCondition + "," + columnFilter + "," + includeContact + "}";
    const params = { params: this.ngaugeService.getHttpParams(filter) };
    return this.httpClient
      .get(this.ngaugeService.getMeldURL("ACCOUNT_OPTIMIZED"), params)
      .map((accountDetails: any) => {
        const account = accountDetails[0];
        account.contact = this.ngaugeService.appendFNameAndLName(
          account.contact
        );
        return account;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/contract.service.ts